// extracted by mini-css-extract-plugin
export default {"delta":"Delta_delta__nAUgu"};